export default __webpack_public_path__ + "static/media/GeorgeHappy.87d1f0da.jpg";